import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    // 检查用户是否有签章授权
    async checkUserSignAuth ({ commit }, params) {
      const response = await axios.post('/sign/v1/checkUserSignAuth', params || {})
      return response.data
    },

    // 申请签章授权（发送短信验证码）
    async sendSignAuth ({ commit }, params) {
      const response = await axios.post('/sign/v1/sendSignAuth', params)
      return response.data
    },

    // 签章授权验证确认
    async confirmSignAuth ({ commit }, params) {
      const response = await axios.post('/sign/v1/confirmSignAuth', params)
      return response.data
    }
  }
}
